export const POLLING_INTERVAL = 1000;
export const MAX_RETRIES_TO_FETCH_IMPORT_JOBS = 10;
